import React from "react";
import { complianceData } from "../data/mock";
import {
  FileCheck,
  Award,
  Shield,
  Leaf,
  Scale,
  BadgeCheck,
} from "lucide-react";
import { Card, CardContent } from "./ui/card";

const iconMap = {
  FileCheck,
  Award,
  Shield,
  Leaf,
  Scale,
  BadgeCheck,
};

export const ComplianceSection = () => {
  return (
    <section id="compliance" className="py-24 md:py-32 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <div className="inline-flex items-center gap-2 bg-emerald-50 rounded-full px-4 py-1.5 mb-6">
              <div className="w-2 h-2 rounded-full bg-emerald-500" />
              <span className="text-emerald-700 text-sm font-semibold uppercase tracking-wider">
                Trust & Compliance
              </span>
            </div>

            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 leading-tight mb-4">
              {complianceData.title}
            </h2>
            <p className="text-slate-500 text-lg leading-relaxed mb-10">
              {complianceData.subtitle}
            </p>

            <div className="grid sm:grid-cols-2 gap-4">
              {complianceData.items.map((item, i) => {
                const Icon = iconMap[item.icon];
                return (
                  <Card
                    key={i}
                    className="border-0 bg-white shadow-sm hover:shadow-md rounded-xl transition-all duration-300 group"
                  >
                    <CardContent className="p-5">
                      <div className="flex items-start gap-3.5">
                        <div className="w-10 h-10 rounded-xl bg-emerald-50 flex items-center justify-center flex-shrink-0 group-hover:bg-emerald-100 transition-colors">
                          {Icon && (
                            <Icon className="w-5 h-5 text-emerald-700" />
                          )}
                        </div>
                        <div>
                          <h4 className="font-bold text-slate-900 text-sm mb-1">
                            {item.title}
                          </h4>
                          <p className="text-slate-500 text-xs leading-relaxed">
                            {item.description}
                          </p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl shadow-emerald-900/10">
              <img
                src={complianceData.image}
                alt="Eco-friendly recycling"
                className="w-full h-[400px] md:h-[520px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-emerald-900/30 to-transparent rounded-2xl" />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-5 left-6 bg-white rounded-2xl shadow-xl shadow-emerald-900/10 p-5 border border-emerald-100 flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-emerald-100 flex items-center justify-center">
                <Shield className="w-6 h-6 text-emerald-700" />
              </div>
              <div>
                <div className="text-sm font-bold text-slate-900">100% Compliant</div>
                <div className="text-xs text-slate-500">All licenses verified</div>
              </div>
            </div>
            {/* Decorative */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-teal-100 rounded-2xl -z-10" />
          </div>
        </div>
      </div>
    </section>
  );
};
